import React from 'react'

export default function InvoiceFooterStyle() {
  return (
    <React.Fragment>
      <style jsx="true">
      {`
        .footer-container {
          display: flex;
          justify-content: flex-end;
        }

        .translist-button-container {
          display: flex;
          padding: 5px;
        }

        /*
        #invoice-session-timer {
          padding: 7px;
          margin: auto 0;
          font-size: 0.65em;
          animation: blurring 500ms;
          flex: 1;
        }
        @keyframes blurring {
          from { opacity: 0 }
          to { opacity: 1 }
        }
        #session-label { font-family: 'Corbel'; }
        #session-timer {
          font-family: 'OCR A';
          font-weight: bold;
          color: #4040FF;
        }
        */

        #new-record-count-container {
          display: flex;
          flex: 3;
          font-size: 0.65em;
          justify-contents: center;
        }

        #new-record-count {
          border-radius: 3px;
          /*border: 1px solid lightblue;*/
          /*background-color: rgba(15, 13, 150, 1);*/
          color: #40FF40;
          padding: 0 7px;
          margin: auto 0;
          /*padding-bottom: 5px;*/
        }

        .notification {
          /*border: 1px solid lightblue;*/
          /*border-radius: 3px;*/
          /*background-color: rgba(8, 80, 10, 1);*/
          color: whitesmoke;
          padding: 0 7px;
          /*padding-bottom: 5px;*/
          margin: auto 0;
        }

        .warehouse-options-container {
          display: flex;
          flex: 2;
          justify-content: flex-start;
        }
        .warehouse-options-container label {
          margin: auto 0;
          padding: 5px;
        }
        .warehouse-options-container select {
          margin: auto;
          margin-left: 0;
          padding: 5px;
        }
        .warehouse-options-container select option {
          font-size: 1rem;
        }
      `}
      </style>
    </React.Fragment>
  )
}
